import { styled } from 'styled-components';

import { _useDispatch, _useSelector } from '@src/state/hooks';
import { useForm } from 'react-hook-form';
import Input from '@src/components/styled/Input';
import SmallButton from '@src/components/styled/SmallButton';
import Form from '@src/components/styled/Form';

import { useRef, useEffect } from 'react';

import _joinGame from '@src/io/events_out/_joinGame';

import _createGame from '@src/io/events_out/_createGame';
import useWagerApprove from '@src/hooks/useWagerApprove';
import useWagerAllowance from '@src/hooks/useWagerAllowance';
import { pushEventQueue, clearEventQueue } from '@src/state/slices/slice_game';

const Container = styled.div`
  position: relative;
  display: flex;
  // flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 10pt;
  border: 2pt solid gray;
  padding-top: 10pt;
  padding-bottom: 10pt;

  width: 100%;
  min-width: 0;
  // overflow-y: scroll;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;

  ${Input} {
    max-width: 14rem;
`;

const GameInfo = styled.div`
  max-width: 16rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 2rem;
  margin-bottom: 5pt;
`;

const Message = styled.div`
  text-align: center;
  max-width: 100%;
  font-size: 2rem;
`;

type Props = {
  gameId: string;
  gameWager: number;
  gameName: string;
};

export default function JoinGameForm(props: Props) {
  const dispatch = _useDispatch();

  const { register, handleSubmit, watch } = useForm();

  const password = watch('password');

  const playerIsGeoblocked = _useSelector(
    (state) => state.app.playerIsGeoblocked,
  );
  const playerCanJoinGame = useRef(!playerIsGeoblocked || !props.gameWager);

  const approve = useWagerApprove();
  const { data: allowance } = useWagerAllowance();

  useEffect(() => {
    playerCanJoinGame.current = !playerIsGeoblocked || !props.gameWager;
  }, [playerIsGeoblocked]);

  const joinGame = () => {
    // if wagered, check allowance and make user approve if necessary
    if (
      props.gameWager &&
      (!allowance || parseFloat(allowance.toString()) < props.gameWager)
    ) {
      dispatch(
        pushEventQueue({
          message: 'Increase your $GOLD allowance to join a challenge game.',
          showToast: true,
          sound: 'yourTurn',
        }),
      );
      approve?.();
    } else {
      dispatch(clearEventQueue());
      _joinGame(props.gameId, password);
    }
  };

  return (
    <Container>
      {playerCanJoinGame.current && (
        <>
          <GameInfo>Joining {props.gameName}</GameInfo>
          <GameInfo>{props.gameWager} $GOLD</GameInfo>
          <Form onSubmit={handleSubmit(joinGame)}>
            <label>
              Password:
              <Input {...register('password')} />
            </label>
            <br />
            <SmallButton type='submit'>JOIN GAME</SmallButton>
          </Form>
        </>
      )}
      {!playerCanJoinGame.current && (
        <Message>This game is not available in your region.</Message>
      )}
    </Container>
  );
}
